import { CanMatchFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../../oglasnik-v3/shared/services/auth.service';
import { UserRole } from '../../oglasnik-v3/shared/models/user-profile.model';
import { roleHomePath } from '../utils/role-home.util';

/**
 * Kombinirani auth + role guard. Factory: prima listu dopuštenih rola (OR).
 * Provjeri login PA rolu (redoslijed bitan — default role() se ne čita za anonimnog).
 * Anonimni → /login; nedopuštena rola → vlastiti home (roleHomePath).
 */
export const roleGuard = (...allowed: UserRole[]): CanMatchFn => () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (!auth.isLoggedIn()) return router.createUrlTree(['/login']);
  return allowed.includes(auth.role())
    ? true
    : router.createUrlTree(roleHomePath(auth.role()));
};

/**
 * Blokira zaštićene rute dok korisnik ne zamijeni privremenu lozinku iz e-maila.
 *
 * Bez ovoga bi ručno upisan /dashboard zaobišao postavljanje: preusmjeravanje
 * nakon prijave je samo navigacija, ne i pravilo.
 */
export const mustSetPasswordGuard: CanMatchFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.mustSetPassword() ? router.createUrlTree(['/postavi-lozinku']) : true;
};

/**
 * Suprotan smjer: na stranicu za postavljanje lozinke ne bi trebao doći nitko
 * tko ondje nema posla — anonimni ide na prijavu, a prijavljeni bez obveze
 * postavljanja na svoj home.
 */
export const setPasswordGuard: CanMatchFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (!auth.isLoggedIn()) return router.createUrlTree(['/login']);
  return auth.mustSetPassword() ? true : router.createUrlTree(roleHomePath(auth.role()));
};
